{
  "EN": {
    "OVERVIEW_TITLE": "Agenda",
    "OVERVIEW_PART": "Part",
    "OVERVIEW_INTRODUCTION_TITLE": "Introduction",
    "OVERVIEW_QUESTIONNAIRE_TITLE": "Questionnaire",
    "OVERVIEW_FINAL_TITLE": "Final",
    "STUDY_START_CONTINUE_BUTTON": "Start the Study",
    "INSTRUCTION_CONTINUE_BUTTON": "Continue",
    "OVERVIEW_CONTINUE_BUTTON": "Continue with next Block",
    "CONSENT_FORM_BUTTON": "Continue",
    "MEDIA_CONTINUE_BUTTON": "Back to Test",
    "MEDIA_INSTRUCTION": {
      "pdf": "Please read the following article.",
      "image": "Please carefully look at the following image."
    },
    "WELCOME_PAGE_HAS_QUESTIONNAIRE": "<p>The test is divided into two parts:</p>",
    "WELCOME_PAGE_NO_QUESTIONNAIRE": "<p>The test consists of one part:</p>",
    "WELCOME_PAGE_QUESTIONNAIRE_DESCRIPTION": "In the second part, we would like to ask you a few quick questions about yourself.",
    "WELCOME_PAGE_IAT_DESCRIPTION": "In the first part, we would like you to perform a few decision tasks.",
    "OUTRO_FINISH_STUDY": {
      "BEFORE_LINK": "Please click",
      "IN_LINK": "here",
      "AFTER_LINK": "to finish the study"
    },
    "READING_MODE_CONTINUE_BUTTON": "Continue",
    "INTERMISSION_CONTINUE_BUTTON": "Continue",
    "IAT_OR_IMAGES": "or images",
    "IAT_CATEGORIES_DIFFERENTIATE": {
      "images": "-related images"
    },
    "IAT_PRACTICE_BLOCK": "<p>In order for you to get used to the task, we start the a practice run.</p>",
    "IAT_WRONG_KEY_PRESS_INSTRUCTION": "<p>If you press the wrong key a red X will appear. Press the other key in order to continue.</p>",
    "QUESTIONNAIRE_PLACEHOLDER_TEXT": "Please enter your answer here...",
    "VALIDATION_HINT": "Please answer all questions",
    "QUESTIONNAIRE_SELECT_PLACEHOLDER": "Please select your answer",
    "QUESTIONNAIRE_SUBMIT_BUTTON_LABEL": "Submit",
    "SLIDER_WARNING": "Please select the correct value",
    "or": "or",
    "MINUTES": "minutes",
    "BLOCK_MAPPING": {
      "0": "first",
      "1": "second",
      "2": "third",
      "3": "fourth",
      "4": "fifth",
      "5": "sixth",
      "6": "seventh",
      "7": "eight",
      "8": "ninth",
      "9": "tenth",
      "10": "eleventh",
      "11": "twelfth",
      "12": "thirteenth",
      "13": "fourteenth",
      "14": "fifteenth",
      "last": "last"
    }
  },
  "DE": {
    "OVERVIEW_TITLE": "Agenda",
    "OVERVIEW_PART": "Teil",
    "OVERVIEW_INTRODUCTION_TITLE": "Einführung",
    "OVERVIEW_QUESTIONNAIRE_TITLE": "Fragebogen",
    "OVERVIEW_FINAL_TITLE": "Ende",
    "STUDY_START_CONTINUE_BUTTON": "Beginne die Studie",
    "INSTRUCTION_CONTINUE_BUTTON": "Weiter",
    "OVERVIEW_CONTINUE_BUTTON": "Weiter mit nächstem Block",
    "CONSENT_FORM_BUTTON": "Weiter",
    "MEDIA_CONTINUE_BUTTON": "Zurück zum Test",
    "MEDIA_INSTRUCTION": {
      "pdf": "Bitte lese den folgenden Artikel.",
      "image": "Bitte sieh dir das folgende Bild genau an."
    },
    "WELCOME_PAGE_HAS_QUESTIONNAIRE": "<p>Die Studie besteht aus zwei Teilen:</p>",
    "WELCOME_PAGE_NO_QUESTIONNAIRE": "<p>Die Studie besteht aus einem Teil:</p>",
    "WELCOME_PAGE_QUESTIONNAIRE_DESCRIPTION": "Im zweiten Teil werden dir noch einmal Fragen zu deiner Person gestellt.",
    "WELCOME_PAGE_IAT_DESCRIPTION": "Im ersten Teil werden wir dir ein paar Entscheidungsaufgaben stellen.",
    "OUTRO_FINISH_STUDY": {
      "BEFORE_LINK": "Bitte klicke",
      "IN_LINK": "hier",
      "AFTER_LINK": ", um die Studie zu beenden."
    },
    "READING_MODE_CONTINUE_BUTTON": "Weiter",
    "INTERMISSION_CONTINUE_BUTTON": "Weiter",
    "IAT_OR_IMAGES": "oder Bilder",
    "IAT_CATEGORIES_DIFFERENTIATE": {
      "images": "-bezogene Bilder"
    },
    "IAT_PRACTICE_BLOCK": "<p>Um dich mit der Aufgabe vertraut zu machen, beginnen wir mit einem Übungsdurchgang.</p>",
    "IAT_WRONG_KEY_PRESS_INSTRUCTION": "<p>Wenn du die falsche Taste drückst, erscheint ein rotes X.</p><p>Drücke dann die andere Taste um fortzufahren</p>",
    "QUESTIONNAIRE_PLACEHOLDER_TEXT": "Bitte gib hier deine Antwort ein...",
    "QUESTIONNAIRE_SELECT_PLACEHOLDER": "Bitte wähle deine Antwort",
    "VALIDATION_HINT": "Bitte alle Fragen beantworten",
    "SLIDER_WARNING": "Bitte wähle den korrekten Wert",
    "or": "oder",
    "MINUTES": "Minuten",
    "BLOCK_MAPPING": {
      "0": "ersten",
      "1": "zweiten",
      "2": "dritten",
      "3": "vierten",
      "4": "fünften",
      "5": "sechsten",
      "6": "siebten",
      "7": "achten",
      "8": "neunten",
      "9": "zehnten",
      "10": "elften",
      "11": "zwölften",
      "12": "dreizehnten",
      "13": "vierzehnten",
      "14": "fünfzehnten",
      "last": "letzten"
    }
  },
  "JP": {
    "OVERVIEW_TITLE": "アジェンダ",
    "OVERVIEW_PART": "部分",
    "OVERVIEW_INTRODUCTION_TITLE": "はじめに",
    "OVERVIEW_QUESTIONNAIRE_TITLE": "アンケート",
    "OVERVIEW_FINAL_TITLE": "最終",
    "STUDY_START_CONTINUE_BUTTON": "調査を開始する",
    "INSTRUCTION_CONTINUE_BUTTON": "続き",
    "OVERVIEW_CONTINUE_BUTTON": "次のブロックに進む",
    "CONSENT_FORM_BUTTON": "続き",
    "MEDIA_CONTINUE_BUTTON": "テストに戻る",
    "MEDIA_INSTRUCTION": {
      "pdf": "以下の記事をお読みください。",
      "image": "次の写真をよくご覧ください。"
    },
    "WELCOME_PAGE_HAS_QUESTIONNAIRE": "<p>この調査は２つのパートで構成されています。</p>",
    "WELCOME_PAGE_NO_QUESTIONNAIRE": "<p>この調査は１つのパートだけで構成されています。</p>",
    "WELCOME_PAGE_QUESTIONNAIRE_DESCRIPTION": "次のパートでは、あなた自身について簡単な質問に回答いただきます。",
    "WELCOME_PAGE_IAT_DESCRIPTION": "最初のパートで、意思決定を伴うタスクを行っていただきます。",
    "OUTRO_FINISH_STUDY": {
      "BEFORE_LINK": "調査を完了するために",
      "IN_LINK": "ここ",
      "AFTER_LINK": "をクリックしてください。"
    },
    "READING_MODE_CONTINUE_BUTTON": "続き",
    "INTERMISSION_CONTINUE_BUTTON": "続き",
    "IAT_OR_IMAGES": "または画像",
    "IAT_CATEGORIES_DIFFERENTIATE": {
      "images": "関連画像"
    },
    "IAT_PRACTICE_BLOCK": "<p>まずは作業に慣れてもらうために、練習から始めます。</p>",
    "IAT_WRONG_KEY_PRESS_INSTRUCTION": "<p>間違ったキーを押すと、赤いX印が表示されます。続行するには、他のキーを押してください。</p>",
    "QUESTIONNAIRE_PLACEHOLDER_TEXT": "ここに答えを入力してください…",
    "QUESTIONNAIRE_SELECT_PLACEHOLDER": "回答を選択してください",
    "VALIDATION_HINT": "すべての質問にお答えください",
    "QUESTIONNAIRE_SUBMIT_BUTTON_LABEL": "送信",
    "SLIDER_WARNING": "正しい値を選択してください。",
    "or": "または",
    "MINUTES": "分",
    "BLOCK_MAPPING": {
      "0": "１番目の",
      "1": "２番目の",
      "2": "３番目の",
      "3": "４番目の",
      "4": "５番目の",
      "5": "６番目の",
      "6": "７番目の",
      "7": "８番目の",
      "8": "９番目の",
      "9": "１０番目の",
      "10": "１１番目の",
      "11": "１２番目の",
      "12": "１３番目の",
      "13": "１４番目の",
      "14": "１５番目の",
      "last": "最後の"
    }
  },
  "NL": {
    "OVERVIEW_TITLE": "Agenda",
    "OVERVIEW_PART": "Deel",
    "OVERVIEW_INTRODUCTION_TITLE": "Introductie",
    "OVERVIEW_QUESTIONNAIRE_TITLE": "Vragenlijst",
    "OVERVIEW_FINAL_TITLE": "Einde",
    "STUDY_START_CONTINUE_BUTTON": "Start de studie",
    "INSTRUCTION_CONTINUE_BUTTON": "Doorgaan",
    "OVERVIEW_CONTINUE_BUTTON": "Doorgaan met het volgende gedeelte",
    "CONSENT_FORM_BUTTON": "Doorgaan",
    "MEDIA_CONTINUE_BUTTON": "Terug naar Test",
    "MEDIA_INSTRUCTION": {
      "pdf": "Lees het volgende artikel.",
      "image": "Kijk in detail naar de afbeelding."
    },
    "WELCOME_PAGE_HAS_QUESTIONNAIRE": "<p>Dit onderzoek is verdeeld in twee delen:</p>",
    "WELCOME_PAGE_NO_QUESTIONNAIRE": "<p>Dit onderzoek bestaat uit één deel:</p>",
    "WELCOME_PAGE_QUESTIONNAIRE_DESCRIPTION": "In het tweede deel zullen we je een paar snelle vragen over jezelf stellen.",
    "WELCOME_PAGE_IAT_DESCRIPTION": "In het eerste deel vragen we je om een paar beslissingstaken uit te voeren.",
    "OUTRO_FINISH_STUDY": {
      "BEFORE_LINK": "Klik a.u.b. ",
      "IN_LINK": "hier",
      "AFTER_LINK": ", om het onderzoek af te ronden"
    },
    "READING_MODE_CONTINUE_BUTTON": "Doorgaan",
    "INTERMISSION_CONTINUE_BUTTON": "Doorgaan",
    "IAT_OR_IMAGES": "of afbeeldingen",
    "IAT_CATEGORIES_DIFFERENTIATE": {
      "images": "-gerelateerde afbeeldingen"
    },
    "IAT_PRACTICE_BLOCK": "<p>Om je te laten wennen aan de taak, starten we de een oefenronde.</p>",
    "IAT_WRONG_KEY_PRESS_INSTRUCTION": "<p>Als je op de verkeerde toets drukt,  verschijnt er een rode X. Druk op de andere toets om verder te gaan.</p>",
    "QUESTIONNAIRE_PLACEHOLDER_TEXT": "Voer hier je antwoord in...",
    "QUESTIONNAIRE_SELECT_PLACEHOLDER": "Voer hier je antwoord in...",
    "VALIDATION_HINT": "Laat alle vragen beantwoord worden",
    "QUESTIONNAIRE_SUBMIT_BUTTON_LABEL": "Versturen",
    "SLIDER_WARNING": "Selecteer de juiste waarde",
    "or": "of",
    "MINUTES": "minuten",
    "BLOCK_MAPPING": {
      "0": "eerste",
      "1": "tweede",
      "2": "derde",
      "3": "vierde",
      "4": "vijfde",
      "5": "zesde",
      "6": "zevende",
      "7": "achtste",
      "8": "negende",
      "9": "tiende",
      "10": "elfde",
      "11": "twaalfde",
      "12": "dertiende",
      "13": "veertiende",
      "14": "vijftiende",
      "last": "laaste"
    }
  }
}
